import React, { useState, useEffect } from 'react';
import Dashboard from './pages/Dashboard.jsx';
import Login from './pages/Login.jsx';
import { CityProvider } from './contexts/CityContext.jsx';
import './App.css';

/**
 * Main App Component
 */
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setIsCheckingAuth(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('authToken');
    // Multi-city state
    localStorage.removeItem('userCities');
    localStorage.removeItem('isSuperAdmin');
    localStorage.removeItem('currentCity');
    setIsAuthenticated(false);
  };

  if (isCheckingAuth) {
    return (
      <>
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
        <div style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'var(--bg-color)',
          color: 'var(--text-secondary)',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            border: '3px solid rgba(200, 161, 71, 0.2)',
            borderTop: '3px solid var(--primary-color)',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}></div>
          <div>Loading...</div>
        </div>
      </>
    );
  }

  return (
    <div className="App">
      {isAuthenticated ? (
        <CityProvider>
          <Dashboard onLogout={handleLogout} />
        </CityProvider>
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
